'use strict';
const angular = require('angular');

export class paymentComponent {
  constructor(StripeElements, Auth, PaymentService, BankingAccountsService) {
    'ngInject';

    this.amount = 0;

    this.StripeElements = StripeElements;
    this.PaymentService = PaymentService;

    this.Auth = Auth;
    this.bankingAccount = {};
    this.bankingAccounts = [];

    BankingAccountsService.getByUser({id: Auth.getCurrentUserSync()._id}, data => {
      this.bankingAccounts = data;
      if (data && data.length) {
        this.bankingAccount = data[0];
      }
    });

    let user = this.Auth.getCurrentUserSync();
    this.name = user.firstName +  ' ' + user.lastName;

    var elements = StripeElements.elements({locale: 'en_US'});
    var element = elements.create('card', {
      style: {
        base: {
          color: '#32325d',
          //lineHeight: '18px',
          //fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          //fontSmoothing: 'antialiased',
          fontSize: 'initial',
          '::placeholder': {
            color: '#aaa'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      }
    });

    element.on('change', (e) => {
      this.cardErrors = e.error ? e.error.message : ''
    });

    this.element = element;

    this.pp = {
      env: "sandbox", // or: "production"

      locale: 'en_US',

      // https://developer.paypal.com/docs/integration/direct/express-checkout/integration-jsv4/customize-button/
      style: {
        size: 'small',
        color: 'gold',
        shape: 'pill',
        label: 'pay'
      },

      client: {
        sandbox:    'AZDxjDScFpQtjWTOUtWKbyN_bDt4OgqaF4eYXlewfBP4-8aqX3PiV8e1GWU6liB2CUXlkA59kJXE7M6R',
        production: ''
      },

      // payment() is called when the button is clicked
      payment: (data, actions) => {
        // Make a call to the REST api to create the payment
        return actions.payment.create({
          payment: {
            transactions: [
              {
                amount: { total: '0.01', currency: 'USD' }
              }
            ]
          }
        });
      },

      // onAuthorize() is called when the buyer approves the payment
      onAuthorize: (data, actions) => {
        // Make a call to the REST api to execute the payment
        return actions.payment.execute().then(() => {

          this.PaymentService.save({
            method: 'paypal',
            amount: this.amount,
            subject: this.subject,
            success: true,
            livemode: this.pp.env !== 'sandbox',
            payload: data,
            meta: {
              creationUser: this.Auth.getCurrentUserSync()._id
            }
          });

          alert('Payment Complete!');
        });
      },

      onCancel: function(data, actions) {
        /*
         * Buyer cancelled the payment
         */
      },

      onError: function(err) {
        /*
         * An error occurred during the transaction
         */
      }
    };
  }

  /**
   * https://support.stripe.com/questions/can-i-charge-my-stripe-fees-to-my-customers
   * https://stackoverflow.com/questions/11832914/round-to-at-most-2-decimal-places-only-if-necessary
   *
   * P_charge = (P_goal + F_fixed) / (1 - F_percent)
   *
   * F_fixed = Fixed fee (paypal & stripe = 0.3)
   * F_percent = Percent fee (paypal & stripe = 2,9%)
   *
   * @returns {number}
   */
  getAmountWithSurcharge(FIXED, PERCENT, CAP) {
    // calc the exact value
    let exactAmount = ((this.amount + FIXED) / (1 - PERCENT));

    if (CAP) {
      let capAmount = this.amount + CAP;

      if (capAmount < exactAmount)
        exactAmount = capAmount;
    }

    // round correctly
    return Math.round(exactAmount * 100) / 100;
  }

  getAmountByType(type, amount) {
    switch (type) {
      case 0:
      case 1:
        return this.getAmountWithSurcharge(0.30, 0.029);
        break;
      case 2:
        return this.getAmountWithSurcharge(0, 0.008, 5.0);
        break;
    }
  }

  payByCard() {
    this.stripeError = false;
    this.stripeProcessing = true;

    let user = this.Auth.getCurrentUserSync();

    this.StripeElements.createToken(this.element,{
      email: user.email
    }).then((result) => {
      // Handle result.error or result.token
      console.log(result);

      let name = user.firstName;
      if (user.middleName)
        name += " " + user.middleName;
      name += " " + user.lastName;

      let amountWithSurcharge = this.getAmountWithSurcharge(0.30, 0.029);
      
      result.amount = amountWithSurcharge*100;  // in stripe: All amounts are in the "smallest common currency unit"
      result.subject = name +  " - " + this.subject;

      if (!result.error) {
        this.PaymentService.stripePayment({userId: user._id}, result, data => {
          console.log(data);
          this.stripeProcessing = false;
          this.stripeSuccess = data.message;
        }, err => {
          this.stripeProcessing = false;

          let error = err.data.message || 'An unkown error occured';
          if (error == 'Invalid positive integer')
            error = 'Invalid Amount';
          this.stripeError = error;
          console.log(err.data);
        })
      } else {
        this.stripeProcessing = false;

        this.stripeError = result.error.message;
        console.log(result.error);
      }
    });
  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  ok() {
    this.close({$value: this.client});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  getInfoText(key) {
    let idx = this.clients.findIndex(o => o.key == key);
    return this.clients[idx].info || '';
  }

}

export default angular.module('condu.paymentComponent', [])
  .component('paymentComponent', {
    template: require('./payment.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: paymentComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/payment/payment.component.js